import { Route } from '@angular/router';
import { AboutComponent } from './about.component';

export const AboutRoutes: Route[] = [
  {
    path: 'about',
    component: AboutComponent
  }
];
